import { render, staticRenderFns } from "./indexPKListZ.vue?vue&type=template&id=67836176&scoped=true&"
import script from "./indexPKListZ.vue?vue&type=script&lang=js&"
export * from "./indexPKListZ.vue?vue&type=script&lang=js&"
import style0 from "./indexPKListZ.vue?vue&type=style&index=0&id=67836176&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67836176",
  null
  
)

export default component.exports